import { putResolve } from 'redux-saga/effects';
import actions from '../../actions';
import * as EditClientAdminMethods from '../../utils/api/superAdmin/EditClientAdminData';

function* EditClientAdminData(payload) {
  const promise = EditClientAdminMethods.EditClientAdminData(payload.payload);
  const { res } = yield promise;
  // Store both Response and Status for displaying status information
  // Handle cases where Status might not exist (backward compatibility)
  yield putResolve({ 
    type: actions.EditClientAdminAction.EDITCLIENTADMINDATA_RECEIVED, 
    data: {
      Response: res.Response,
      Status: res.Status || null
    }
  });
}

export { EditClientAdminData };
